import { camelizeKeys } from 'humps';

export const fetcher = async <T>(url: string): Promise<T> => {
  const res = await fetch(url);
  const json = await res.json();
  return camelizeKeys(json) as unknown as T;
};
